export default [
    /*登录*/
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index')
    },
    /*首页*/
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/home/index')
    },
    /*关注*/
    {
      path: '/home/followInfo',
      name: 'followInfo',
        component:() => import('@/views/home/followInfo')
    },
    /*官方号*/
    {
        path: '/home/officialNo',
        name: 'officialNo',
        component:() => import('@/views/home/officialNo')
    },
    /*忘记密码*/
    {
        path: '/ForgotPassword',
        name: 'ForgotPassword',
        component: () => import('@/views/login/ForgotPassword')
    },
    /*账号注册*/
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/register')
    },
    /*文章详情*/
    {
        path: '/article/articleDetails',
        name: 'articleDetails',
        component: () => import('@/views/article/articleDetails')
    },
    /*视频文章详情*/
    {
        path: '/article/videoDetails',
        name: 'videoDetails',
        component: () => import('@/views/article/videoDetails')
    },
    /*文章详情2*/
    {
        path: '/article/DynamicDetail',
        name: 'DynamicDetail',
        component: () => import('@/views/article/DynamicDetail')
    },
    /*政策详情*/
    {
        path: '/article/policyDetails',
        name: 'policyDetails',
        component: () => import('@/views/article/policyDetails')
    },
    /*搜索界面*/
    {
        path: '/search',
        name: 'search',
        component: () => import('@/views/home/search')
    },
    /*个人信息*/
    {
        path: '/userInfo/index',
        name: 'userInfo',
        component: () => import('@/views/home/userInfo/index')
    },
    /*企业服务网*/
    {
        path: '/serviceNet/localServe',
        name: 'localServe',
        component: () => import('@/views/home/serviceNet/localServe')
    },
    /*企服务云*/
    {
        name: 'serviceCloud',
        path: '/ServiceCentre/serviceCloud',
        component: () => import('@/views/ServiceCentre/serviceCloud')
    },
    /*切换节点*/
    {
        name: 'switchNode',
        path: '/ServiceCentre/switchNode',
        component: () => import('@/views/ServiceCentre/switchNode')
    },
    /*云平台*/
    {
        name: 'platform',
        path: '/cloudPlatform/platform',
        component: () => import('@/views/cloudPlatform/platform')
    },
    /*全部服务分类*/
    {
        name: 'AllService',
        path: '/cloudPlatform/AllService',
        component: () => import('@/views/cloudPlatform/AllService')
    },
    /*产品详情*/
    {
        name: 'productDetails',
        path: '/cloudPlatform/productDetails',
        component: () => import('@/views/cloudPlatform/productDetails')
    },
    /*店铺*/
    {
        path: '/storeManagement/shop',
        name: 'shop',
        component: () => import('@/views/storeManagement/shop')
    },
    /*提交订单*/
    {
        name: 'order',
        path: '/payment/order',
        component: () => import('@/views/payment/order')
    },
    /*微信支付*/
    {
        name: 'payCheck',
        path: '/payment/payCheck',
        component: () => import('@/views/payment/payCheck')
    },
    /*支付成功*/
    {
        name: 'paySuccess',
        path: '/payment/paySuccess',
        component: () => import('@/views/payment/paySuccess')
    },
    /*订单详情*/
    {
        name: 'orderDetails',
        path: '/payment/orderDetails',
        component: () => import('@/views/payment/orderDetails')
    },
    /*个人中心导航栏*/
    {
        name: 'personal',
        path: '/personal/index',
        component:()=>import('@/views/personal/index')
    },
    /*订单管理*/
    {
        name: 'orderManagement',
        path: '/orderManagement/index',
        component:()=>import('@/views/orderManagement/index')
    },
    /*账号管理*/
    {
        name: 'accountManagement',
        path: '/accountManagement/index',
        component:()=>import('@/views/accountManagement/index')
    },
    /*在线客服*/
    {
        name: 'onlineService',
        path: '/onlineService/index',
        component:()=>import('@/views/onlineService/index')
    },
    /*编辑资料*/
    {
        name: 'editInformation',
        path: '/personal/editInformation',
        component:()=>import('@/views/personal/editInformation')
    },
    /*关注店铺*/
    {
        name: 'follow',
        path: '/personal/follow',
        component:()=>import('@/views/personal/follow')
    },
    /*优惠券*/
    {
        name: 'coupon',
        path: '/personal/coupon',
        component:()=>import('@/views/personal/coupon')
    },
    /*我的收藏*/
    {
        name: 'mineCollection',
        path: '/personal/mineCollection',
        component:()=>import('@/views/personal/mineCollection')
    },
    /*收货地址*/
    {
        name: 'shipAddress',
        path: '/personal/shipAddress',
        component:()=>import('@/views/personal/shipAddress')
    },
    /*意见反馈*/
    {
        name: 'feedback',
        path: '/personal/feedback',
        component:()=>import('@/views/personal/feedback')
    },
    /*关于我们*/
    {
        name: 'aboutUs',
        path: '/personal/aboutUs',
        component:()=>import('@/views/personal/aboutUs')
    },
    /*绑定手机*/
    {
        name:'bindMobile',
        path: '/accountManagement/bindMobile',
        component:()=>import('@/views/accountManagement/bindMobile')
    },
    /*实名认证*/
    {
        name:'certification',
        path: '/accountManagement/certification',
        component:()=>import('@/views/accountManagement/certification')
    },
    /*登录密码*/
    {
        name:'loginPassword',
        path: '/accountManagement/loginPassword',
        component:()=>import('@/views/accountManagement/loginPassword')
    },
    /*邮箱绑定*/
    {
        name:'bindEmail',
        path: '/accountManagement/bindEmail',
        component:()=>import('@/views/accountManagement/bindEmail')
    },
    /*登录保护*/
    {
        name:'loginProtection',
        path: '/accountManagement/loginProtection',
        component:()=>import('@/views/accountManagement/loginProtection')
    },
    /*全部订单*/
    {
        name:'AllOrder',
        path: '/orderManagement/AllOrder',
        component:()=>import('@/views/orderManagement/AllOrder')
    },
    /*待付款*/
    {
        name:'toPaid',
        path: '/orderManagement/AllOrder',
        component:()=>import('@/views/orderManagement/toPaid')
    },
    /*服务中*/
    {
        name: 'inService',
        path: '/orderManagement/inService',
        component:()=>import('@/views/orderManagement/inService')
    },
    /*待评价*/
    {
      name: 'toEvaluated',
      path: '/orderManagement/toEvaluated',
      component:()=>import('@/views/orderManagement/toEvaluated')
    },
    /*已完成*/
    {
        name: 'completed',
        path: '/orderManagement/completed',
        component:()=>import('@/views/orderManagement/completed')
    },
    /*订单详情*/
    {
        name:'orderDetails',
        path: '/orderManagement/orderDetails',
        component:()=>import('@/views/orderManagement/orderDetails')
    },
    /*申请售后*/
    {
        name:'applyAfterSales',
        path: '/orderManagement/applyAfterSales',
        component:()=>import('@/views/orderManagement/applyAfterSales')
    },
    /*外包需求*/
    {
        name:'outsourceDemand',
        path: '/outsourceDemand/index',
        component:()=>import('@/views/outsourceDemand/index')
    },
    /*发布需求*/
    {
        name: 'releaseDemand',
        path: '/outsourceDemand/releaseDemand',
        component:()=>import('@/views/outsourceDemand/releaseDemand')
    },
    /*我的招标*/
    {
        name: 'mineBidding',
        path: '/outsourceDemand/mineBidding',
        component:()=>import('@/views/outsourceDemand/mineBidding')
    },
    /*我的投标*/
    {
        name: 'mineBid',
        path: '/outsourceDemand/mineBid',
        component:()=>import('@/views/outsourceDemand/mineBid')
    },
    /*我的收藏*/
    {
        name: 'mineCollection',
        path: '/outsourceDemand/mineCollection',
        component:()=>import('@/views/outsourceDemand/mineCollection')
    },
    /*招标详情*/
    {
        name: 'biddingDetails',
        path: '/outsourceDemand/biddingDetails',
        component:()=>import('@/views/outsourceDemand/biddingDetails')
    },
    /*投标详情*/
    {
        name: 'bidDetails',
        path: '/outsourceDemand/bidDetails',
        component:()=>import('@/views/outsourceDemand/bidDetails')
    },
    /*投标报价*/
    {
        name: 'tenderOffer',
        path: '/outsourceDemand/tenderOffer',
        component:()=>import('@/views/outsourceDemand/tenderOffer')
    },
    /*报价标书*/
    {
        name: 'bidingDoc',
        path: '/outsourceDemand/bidingDoc',
        component:()=>import('@/views/outsourceDemand/bidingDoc')
    },
    /*企业招聘*/
    {
        name: 'recruit',
        path: '/recruit/index',
        component:()=>import('@/views/recruit/index')
    },
    /*职位详情*/
    {
        name: 'positionDetails',
        path: '/recruit/positionDetails',
        component:()=>import('@/views/recruit/positionDetails')
    },
    /*银企服务*/
    {
        name: 'loan',
        path: '/loan/index',
        component:()=>import('@/views/loan/index')
    },
    /*银企服务详情*/
    {
        name: 'serviceDetails',
        path: '/loan/serviceDetails',
        component:()=>import('@/views/loan/serviceDetails')
    },
    /*需求申报*/
    {
        name:'declaration',
        path: '/declaration/index',
        component:()=>import('@/views/declaration/index')
    },
    /*企业培育*/
    {
        name:'cultivation',
        path: '/cultivation/index',
        component:()=>import('@/views/cultivation/index')
    },
    /*企业高质量发展培育*/
    {
        name:'development_cultivation',
        path: '/cultivation/development_cultivation',
        component:()=>import('@/views/cultivation/development_cultivation')
    },
    /*企业服务资源池管理系统*/
    {
        name:'resourcePoolSystem',
        path: '/cultivation/resourcePoolSystem',
        component:()=>import('@/views/cultivation/resourcePoolSystem')
    },
    /*培育申报*/
    {
        name:'fillGrowth',
        path: '/cultivation/fillGrowth',
        component:()=>import('@/views/cultivation/fillGrowth')
    },
    /*企业查询*/
    {
        name:'enterpriseSearch',
        path: '/enterpriseSearch/index',
        component:()=>import('@/views/enterpriseSearch/index')
    },
    /*开庭公告*/
    {
        name:'courtNotice',
        path: '/enterpriseSearch/courtNotice',
        component:()=>import('@/views/enterpriseSearch/courtNotice')
    },
    /*企业查询-招投标*/
    {
        name:'search_bidding',
        path: '/enterpriseSearch/bidding',
        component:()=>import('@/views/enterpriseSearch/bidding')
    },
    /*企业查询-法院公告*/
    {
        name:'court',
        path: '/enterpriseSearch/court',
        component:()=>import('@/views/enterpriseSearch/court')
    },
    /*企业查询-被执行人*/
    {
        name:'executor',
        path: '/enterpriseSearch/executor',
        component:()=>import('@/views/enterpriseSearch/executor')
    },
    /*企业查询-信用评级*/
    {
        name:'creditRating',
        path: '/enterpriseSearch/creditRating',
        component:()=>import('@/views/enterpriseSearch/creditRating')
    },
    /*企业查询-行政处罚*/
    {
        name:'administrativeSanction',
        path: '/enterpriseSearch/administrativeSanction',
        component:()=>import('@/views/enterpriseSearch/administrativeSanction')
    },
    /*企业查询-裁判文书*/
    {
        name:'adjudicativeDocument',
        path: '/enterpriseSearch/adjudicativeDocument',
        component:()=>import('@/views/enterpriseSearch/adjudicativeDocument')
    },
    /*企业查询-进出口信用*/
    {
        name:'impOrExpCredit',
        path: '/enterpriseSearch/impOrExpCredit',
        component:()=>import('@/views/enterpriseSearch/impOrExpCredit')
    },
    /*企业查询-司法拍卖*/
    {
        name:'judicialSale',
        path: '/enterpriseSearch/judicialSale',
        component:()=>import('@/views/enterpriseSearch/judicialSale')
    },
    /*企业查询-企业信息库*/
    {
        name:'infoBase',
        path: '/enterpriseSearch/infoBase',
        component:()=>import('@/views/enterpriseSearch/infoBase')
    },
    /*企业查询-上市公司*/
    {
        name:'listedCompany',
        path: '/enterpriseSearch/listedCompany',
        component:()=>import('@/views/enterpriseSearch/listedCompany')
    },
    /*企业查询-融资事件*/
    {
        name:'financing',
        path: '/enterpriseSearch/financing',
        component:()=>import('@/views/enterpriseSearch/financing')
    },
    /*企业查询-投资机构*/
    {
        name:'investmentInstitutions',
        path: '/enterpriseSearch/investmentInstitutions',
        component:()=>import('@/views/enterpriseSearch/investmentInstitutions')
    },
    /*企业查询-产业链*/
    {
        name:'industrialChain',
        path: '/enterpriseSearch/industrialChain',
        component:()=>import('@/views/enterpriseSearch/industrialChain')
    },
    /*企业查询-产业园区*/
    {
        name:'industrialPark',
        path: '/enterpriseSearch/industrialPark',
        component:()=>import('@/views/enterpriseSearch/industrialPark')
    },
    /*企业查询-债券*/
    {
        name:'bond',
        path: '/enterpriseSearch/bond',
        component:()=>import('@/views/enterpriseSearch/bond')
    },
    /*企业查询-企业标签查询*/
    {
        name:'enterpriseTagQuery',
        path: '/enterpriseSearch/enterpriseTagQuery',
        component:()=>import('@/views/enterpriseSearch/enterpriseTagQuery')
    },
    /*企业查询-招投标详情*/
    {
        name:'enterpriseBiddingDetails',
        path: '/enterpriseSearch/biddingDetails',
        component:()=>import('@/views/enterpriseSearch/biddingDetails')
    },
    /*招聘详情*/
    {
        name: 'positionDetail',
        path: '/serviceNet/positionDetails',
        component: () => import('@/views/home/serviceNet/positionDetails')
    },
    /**------------------------------企业详情---------------------------------------*/
    /*企业详情*/
    {
        name:'enterpriseDetails',
        path: '/enterpriseDetails/index',
        component:()=>import('@/views/enterpriseDetails/index')
    },
    {
        name:'textDetails',
        path: '/enterpriseDetails/textDetails',
        component:()=>import('@/views/enterpriseDetails/textDetails')
    },
    {
        name:'investmentInstitutions',
        path: '/enterpriseDetails/investmentInstitutions',
        component:()=>import('@/views/enterpriseDetails/investmentInstitutions')
    },
    {
        name:'legalProceedingsDetail',
        path: '/enterpriseDetails/legalProceedingsDetail',
        component:()=>import('@/views/enterpriseDetails/legalProceedingsDetail')
    },
    {
        name:'limitedConsumption',
        path: '/enterpriseDetails/limitedConsumption',
        component:()=>import('@/views/enterpriseDetails/limitedConsumption')
    },
    {
        name:'annualReports',
        path: '/enterpriseDetails/annualReports',
        component:()=>import('@/views/enterpriseDetails/annualReports')
    },
    {
        name:'BiddingDetail',
        path: '/serviceNet/BiddingDetails',
        component:()=>import('@/views/home/serviceNet/BiddingDetails')
    },
    /*项目辅导*/
    {
        name:'projectCoach',
        path: '/projectCoach/index',
        component:()=>import('@/views/projectCoach/index')
    },
    /*惠企政策申报详情*/
    {
        name:'declareRankDetails',
        path: '/projectCoach/declareRankDetails',
        component:()=>import('@/views/projectCoach/declareRankDetails')
    },
    /*企业获得补贴详情*/
    {
        name:'subsidyRankDetails',
        path: '/projectCoach/subsidyRankDetails',
        component:()=>import('@/views/projectCoach/subsidyRankDetails')
    },
    /*商务合作*/
    {
        name: 'businessCooperation',
        path: '/businessCooperation/index',
        component:()=>import('@/views/businessCooperation/index')
    },
    /*官方号列表*/
    {
        name: 'officialNumberAll',
        path: '/officialCloud/officialNumberAll',
        component:()=>import('@/views/officialCloud/officialNumberAll')
    },
    /*开通云官网首页*/
    {
        name: 'enterpriseCertification',
        path: '/officialCloud/enterpriseCertification',
        component:()=>import('@/views/officialCloud/enterpriseCertification')
    },
    /*官方号详情*/
    {
        name: 'officialNumberDetails',
        path: '/officialCloud/officialNumberDetails',
        component:()=>import('@/views/officialCloud/officialNumberDetails')
    }
]